function get_the_step_no(input){
  const parent_step_no = input.closest(".steps_hidden");          
  const step = parent_step_no.querySelector(".qus-numb");      
  const step_no = Number(step?.innerHTML.trim());  
  return step_no;
}

// save and display data 
function saveAndDisplay(container, storageKey, title, values = null) {
  const data = JSON.parse(localStorage.getItem(storageKey) || "[]");
  const idx = data.findIndex(item => item.title === title);
  if (idx > -1) {
    data[idx].values = values;
  } else {
    data.push({ title, values });
  }
  localStorage.setItem(storageKey, JSON.stringify(data));

  // const valueText = Object.entries(values)
  //   .map(([k, v]) => `${k} = ${v}`)
  //   .join(", ");

  // if (values && (Array.isArray(values) || typeof values === "object")) {
  //   valueText = Object.entries(values).map(([k, v]) => `${k} = ${v}`).join(", ");
  // } else {
  //   valueText = values;
  // }
  let valueText = null;

  if (values !== null && values !== undefined) {
    if (Array.isArray(values) || typeof values === "object") {
      valueText = Object.entries(values)
        .map(([k, v]) => `${k} = ${v}`)
        .join(", ");
    } else {
      valueText = values;
    }
  }


  let li = container?.querySelector(`li[data-title="${title}"]`);
  if (!li) {
    li = document.createElement("li");
    li.setAttribute("data-title", title);
    container?.appendChild(li);
  }

  // li.innerHTML = `<p>${title}</p>
  //   <p>${valueText}</p>`;
    li.innerHTML = `
      <p>${title}</p>
      ${values !== null && values !== undefined
        ? `<p>${valueText}</p>`
        : ""
      }
    `;
}  

// credit step
summaryCheckboxAddLoac();

// custom-sorting on configer form
  document.getElementById("sorting-dropdown")?.addEventListener("change", function () {
    var selectedOption = this.value;
    sortBlogPosts(selectedOption);
  });

  document.getElementById("credit-sorting-dropdown")?.addEventListener("change", function () {
    var selectedOption = this.value;
    sortBlogPosts(selectedOption);
  });
  
  function sortBlogPosts(option) {
    var postsContainers = document.querySelectorAll(".product-card-sorting");
    postsContainers?.forEach(function (postsContainer) {
    var postsArray = Array.from(postsContainer.querySelectorAll(".cust_sort_blog"));
  
    switch (option) {
      case "title-ascending":
        postsArray.sort(function (a, b) {
          var titleA = a.querySelector(".product-card-title").textContent.trim();
          var titleB = b.querySelector(".product-card-title").textContent.trim();
          return titleA.localeCompare(titleB);
        });
        break;
  
      case "title-descending":
        postsArray.sort(function (a, b) {
          var titleA = a.querySelector(".product-card-title").textContent.trim();
          var titleB = b.querySelector(".product-card-title").textContent.trim();
          return titleB.localeCompare(titleA);
        });
        break;
  
      default:
        // Do nothing for default
        return;
    }
  
    // Clear and re-append sorted posts
    postsContainer.innerHTML = "";
    postsArray.forEach(function (post) {
      postsContainer.appendChild(post);
    });
    });
  }

   

  // step 6 hide show tab and add tag
  function initTabsAndInputs() {
    document.querySelectorAll("details")?.forEach(function (detailsBlock) {
      const tabButtons = detailsBlock.querySelectorAll(".tab-button");
      
      const inputButtons = detailsBlock.querySelectorAll(".collapsible-card .button_tab_inp");
  
      // Avoid duplicate bindings by checking if already initialized
      if (detailsBlock.dataset.initDone) return;
      detailsBlock.dataset.initDone = "true";
  
      // Tab switching logic
      tabButtons?.forEach(tab => {
        tab.addEventListener("click", function () {      
          tabButtons?.forEach(btn => btn.classList.remove("active"));
          this.classList.add("active");
  
          detailsBlock.querySelectorAll(".tab-section")?.forEach(section => {
            section.classList.remove("visible");
          });
  
          const targetClass = this.getAttribute("data-target");
          detailsBlock.querySelector(`.${targetClass}`)?.classList.add("visible");
        });
      });
  
  
      // Input button logic
      inputButtons?.forEach(btn => {
        btn.addEventListener("change", function () {
          // console.log("btn",btn)
          const parent = this.closest(".pro-card-details");
          const sensorData = this.getAttribute("sensor-val-attr");
          const sensorDataName = this.name;
          const sensorhandle = this.getAttribute("data-tabsensor-handle");
          const kabelData = this.getAttribute("kabel-val-attr");
          const kabelDataName = this.name;
          const kabelhandle = this.getAttribute("data-tabkabel-handle");
          const card_parent = this.closest(".grid__item");
          const label_show = card_parent?.querySelector(".selected_product_tag");
          console.log("sensorData",sensorData,"kabelData",kabelData);
          if (sensorData) {
            parent.querySelectorAll(".button_tab_inp[sensor-val-attr]")?.forEach(inp => {
              const card_parent = inp.closest(".grid__item");
              const label_show = card_parent.querySelector(".selected_product_tag");
              inp.value = "";
              label_show.innerHTML = "";
            });
  
            const label_text = btn.getAttribute("data-tag-text");
            if (label_text) label_show.innerHTML = label_text;
  
            let input_val = card_parent.querySelector(".quantity__input").value;  
            if(input_val && !card_parent.classList.contains("active")){
              input_val = parseInt(input_val) + 1
              const qty_inp = card_parent.querySelector(".quantity__input"); 
              if(qty_inp)qty_inp.value = input_val;
            }  

            const step_no = get_the_step_no(this); 
             renderSelectedProducts(sensorhandle, sensorDataName, input_val, step_no);

            this.value = sensorData;
            parent.querySelector(".after_sensor")?.classList.add("active");
            parent.querySelector(".befor_sensor")?.classList.remove("active");
  
          } else if (kabelData) {
            parent.querySelectorAll(".button_tab_inp[kabel-val-attr]")?.forEach(inp => {
              const card_parent = inp.closest(".grid__item");
              const label_show = card_parent?.querySelector(".selected_product_tag");
              inp.value = "";
              label_show.innerHTML = "";
            });
  
            const label_text = btn.getAttribute("data-tag-text");
            if (label_text) label_show.innerHTML = label_text;
            let input_val = card_parent.querySelector(".quantity__input").value;  
              if(input_val && !card_parent.classList.contains("active")){
                input_val = parseInt(input_val) + 1
                const qty_inp = card_parent.querySelector(".quantity__input"); 
                if(qty_inp)qty_inp.value = input_val;
              }    

               const step_no = get_the_step_no(this);
              renderSelectedProducts(kabelhandle, kabelDataName, input_val, step_no);
            this.value = kabelData;
            parent.querySelector(".after_cabel")?.classList.add("active");
            parent.querySelector(".befor_cabel")?.classList.remove("active");
          }
        });
      });
    });
  }
  
  document.addEventListener("DOMContentLoaded", initTabsAndInputs);
  // Observe DOM changes for dynamically added elements
  const observer = new MutationObserver(() => {
    initTabsAndInputs();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  
  
    // step one in pre selected product in step 2
  const accordion_second_product = document.querySelectorAll(".second-step .accordion-image-title-content-item .accordion_input");
  accordion_second_product?.forEach(input => {
    const click_btn = input.closest(".accordion__content");
    const main_form = input.closest("configure-form").querySelector(".selected_multi_acc.sixth-step");
    click_btn.classList.remove("clicked_according")
    input.addEventListener("change", async () => {    
      const handle = input.getAttribute("pre_product_gehuse") || input.getAttribute("pre-selecetd-handle");
      click_btn.classList.add("clicked_according");
      
      const main = input.closest("configure-form");
      const preselect_checkbox = [...main.querySelectorAll("[that-checkbox-preselect]")]
      // const radio =  matchedCard?.querySelector(".variant-radio")?.click();
      preselect_checkbox.forEach(checkbox => {
        checkbox.click();
      });
      

         const clickedInput = input.getAttribute("pre_product_zubehor");
        if (!clickedInput) return;

        const normalizeHandle = (str) =>str?.toString().trim().toLowerCase().replace(/®/g, '').replace(/\s+/g, '');
        const parsedProducts = clickedInput.split(",").map(item => {
          const [handle, quantity] = item.split("^_^");
          return {
            handle: normalizeHandle(handle),
            quantity: quantity || 1
          };
        });

        console.log("parsedProducts =", parsedProducts);
        const variantInputs = document.querySelectorAll(".eighth_step .tab-panel .tab_product_inp[data-tab-product-handle]");

        variantInputs.forEach(el => {
          const rawHandle = el.getAttribute("data-tab-product-handle");
          const productHandle = normalizeHandle(rawHandle);
          const matched = parsedProducts.find(p => p.handle === productHandle);
          console.log("Checking:", productHandle, "Matched:", matched);
          if (matched) {
            const btn_input = el.closest(".grid__item")?.querySelector(".cust_btn_select");
            if (btn_input) {
              btn_input.click();   // or btn_input.checked = true;
            }
          }
        });
        
        
    });
  });

// step 8  tab-with-product
  document.querySelectorAll('[tab-button]').forEach(function(tabBtn) {
    tabBtn?.addEventListener('click', function() {
      var target = this.getAttribute('data-target');
  
      // Remove active + hide all panels
      document.querySelectorAll('[tab-button]').forEach(el => el.classList.remove('active'));
      document.querySelectorAll('[tab-panel]').forEach(el => {
        el.classList.remove('active');
        el.classList.add('hidden');
      });
  
      // Activate clicked tab + corresponding panel
      this.classList.add('active');
      var targetPanel = document.getElementById(target);
      if (targetPanel) {
        targetPanel.classList.add('active');
        targetPanel.classList.remove('hidden');
      }
    });
  });


   // result step 12
  const accordian_twelth = document.querySelectorAll(".Twelfth_step .accordion-image-title-content-item .accordion_input");
  // localStorage.removeItem('twelth_accordian_info');
  accordian_twelth?.forEach(input => {
    input?.addEventListener("change", function (inp) {
      const wrapper = input.closest(".accordion-image-title-content-item-inner");
      const acc_title = wrapper?.querySelector(".build-title")?.innerHTML;
      const acc_content = wrapper?.querySelector(".accordion-image-content")?.innerHTML;  
      let acc_stored = [];
      if( acc_title || acc_content){
        acc_stored.push({ acc_title: acc_title,acc_content: acc_content});
        localStorage.setItem("twelth_accordian_info", JSON.stringify(acc_stored));
        let saved_acc = JSON.parse(localStorage.getItem("twelth_accordian_info") || "[]");
        if (saved_acc.length > 0) {
          const { acc_title, acc_content } = saved_acc[0];
          const acc_show_title = document.querySelector(".hardware_pdp_multi_checkbox .show_pdp_title");
          const acc_show_content = document.querySelector(".hardware_pdp_multi_checkbox .show_pdp_content");
          if (acc_show_title) acc_show_title.innerHTML = acc_title;
          if (acc_show_content) acc_show_content.innerHTML = acc_content;
        }
      }    
    });
  });

  
  async function selectedAccordionProductShowMulti(handle,collections_infor) {
    try {
      const response = await fetch(`/products/${handle}?view=selected_multi_acc`);
      const productHTML = await response.text();      
      const parser = new DOMParser();
      const doc = parser.parseFromString(productHTML, 'text/html');
      const mainDivEl = doc.querySelector('metawise-variant-selector');  
      if(mainDivEl){
        return mainDivEl;
      }else{
        return null;
      }
        // mainDiv: mainDivEl ? mainDivEl.outerHTML : '',     
    } catch (error) {
      console.error('Error fetching product info:', error);
      return null;
    }
  }


   async function selectedMultiProductShow(handle) {
    try {
      const response = await fetch(`/products/${handle}?view=multi_content`);
      const productHTML = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(productHTML, 'text/html');
      const mainDivEl = doc.querySelector('.multi_product_info');
      if(mainDivEl){
        return mainDivEl;
      }else{
        return null;
      }
      return   
  
    } catch (error) {
      console.error('Error fetching product info:', error);
      return null;
    }
  }


// function updateSelectedProducts(input) {
//   const currentStep = input.closest(".cust-form-wrapp");
//   if (!currentStep) return;

//   let stored = JSON.parse(localStorage.getItem("selectedProducts") || "[]");
//   const checkboxes = [...currentStep.querySelectorAll(".is_product_in_atc")];
//   const names = [...new Set(checkboxes.map(el => el.getAttribute("name") || ""))];  
//   stored = stored.filter(item => !names.includes(item.name));
//   const stepProducts = [];

//   checkboxes.forEach(el => {
//     const name = el.getAttribute("name") || "";

//     if (el.checked) {  
//       const handles = (el.getAttribute("pre-selecetd-handle") || "").split(",").filter(Boolean);
//       handles.forEach(handle => {
//         const product = { handle, name, quantity: 1, sku: };
//         stored.push(product);
//         stepProducts.push(product);       
//       });
//     } else {      
//       const fallbackHandle = el.getAttribute("enable-selecetd-handle");
//       if (fallbackHandle) {
//         const product = {
//           handle: fallbackHandle,
//           name,
//           quantity: 1
//         };

//         stored.push(product);
//         stepProducts.push(product);
//       }
//     }
//   });
//   stored.push(...stepProducts);

//     preSelectedProductClick(stored);
  
//   localStorage.setItem("selectedProducts", JSON.stringify(stored));
//   localStorage.setItem("resultProduct", JSON.stringify(stored));

//     window.selected_data = window.selected_data || {};
//     window.selected_data["services"] = stepProducts;
// }

function updateSelectedProducts(input) {
  const step = input.closest(".cust-form-wrapp");
  if (!step) return;

  let stored = JSON.parse(localStorage.getItem("selectedProducts") || "[]");
  const checkboxes = [...step.querySelectorAll(".is_product_in_atc")];
  const names = [...new Set(checkboxes.map(el => el.name || ""))];

  stored = stored.filter(item => !names.includes(item.name));
  const stepProducts = [];

  checkboxes.forEach(el => {
    const checked = el.checked;
    const prefix = checked ? "pre-selecetd" : "enable-selecetd";
    const handles = (el.getAttribute(`${prefix}-handle`) || "").split(",").filter(Boolean);
 
    handles.forEach((handle, i) => {
      const product = {
        handle: handle.trim(),
        name: el.name || "",
        quantity: 1
      };

      stored.push(product);
      stepProducts.push(product);
    });
  });

  console.log("function called...",stepProducts);
    // setTimeout(() => { 
      preSelectedProductClick(stepProducts, input);
    // }, 500);

  localStorage.setItem("selectedProducts", JSON.stringify(stored));
  localStorage.setItem("resultProduct", JSON.stringify(stored));

  window.selected_data = window.selected_data || {};
  window.selected_data.services = stepProducts;
}

function preSelectedProductClick(store, input) {
  const mainParent = input.closest(".cust-form-wrapp");
  const metaParent = mainParent?.nextElementSibling;
  console.log("metaParent",metaParent);
  if (!metaParent) return;
  const card_content = metaParent?.querySelector(".main-tab-products-content");
  const selecetd_data_parent = metaParent?.querySelector(".selected_product_details"); 

    selecetd_data_parent.querySelectorAll(".slot").forEach(selected => {
      const input_data = selected.querySelector(".meta-slot-input.active");
      const handle = selected.getAttribute("data-meta-handle");
      if (!store.some(product => product.handle === handle)) {            
        console.log("handle",handle);
        selected.querySelector(".remove-second-btn")?.click();
      }
      
    });    
 

    metaParent.querySelectorAll(".card_product_custom").forEach(card => {
      const handle = card.getAttribute("data-product-handle");
        console.log("handle matchedd",handle,"store",store);
      if (store.some(product => product.handle === handle)) {
        console.log("card matched",card);
        const button_inp = card.querySelector(".variant-checkbox");
        button_inp?.click();      
      }
    });
  

}

async function cardProduct(handle) {
  try {
    const response = await fetch(`/products/${handle}?view=card_product`);
    const productHTML = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(productHTML, 'text/html');
    const mainDivEl = doc.querySelector('.card_product_custom');
    if(mainDivEl){
      return mainDivEl;
    }else{
      return null;
    }
    return   

  } catch (error) {
    console.error('Error fetching product info:', error);
    return null;
  }
}


const accordian_fifth = document.querySelectorAll(".accordion-image-title-content-item .accordion_input.content_show_local");
accordian_fifth?.forEach(input => {
  input.addEventListener("change", function () {
    console.log("change called..");
    updateSelectedProducts(input);
  });
});



// =============== Dynamic Metafield Slot Selector =============== //
class MetaVariantSelector extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
    const observer = new MutationObserver(() => {
      this.init();
    });
    observer.observe(this, { childList: true, subtree: true });
  }

  init() {
    this.slotInputs = Array.from(this.querySelectorAll(".meta-slot-input"));      
    this.totalSlots = this.slotInputs.length;

    
    this.setupSlotInputChange(); 
    this.setupRadioListeners();
    this.setupcheckboxListeners();
    this.checkInpNoProductDisable();
    this.popup_show_close();
    this.extraQtyChangeSku();
    // this.pagination_click();
    // this.checkQtyButtonState();
  }

  handleSelection(input) {
    const card = input.closest(".grid__item");
    const tab = input.closest(".selecetd_product_tab");
    const details = card?.closest(".pro-card-details");
    const label = card?.querySelector(".selected_product_tag");
    const qtyInput = card?.querySelector(".quantity__input.quantity_product_card");    

    const isFirst = tab?.hasAttribute("data-first-collection");
    const isSecond = tab?.hasAttribute("data-second-collection");

    const handle = input.dataset.varHandle;
    const name = input.name;
    const labelText = input.dataset.tagText || "";
    const quantity = parseInt(qtyInput?.value || "1", 10);    
    
    let stored = JSON.parse(localStorage.getItem("selectedProducts")) || [];
    let stored_slot = JSON.parse(localStorage.getItem("slotproduct")) || [];  

    const index = stored.findIndex(item => item.handle === handle);   
    const index_slot = stored_slot.findIndex(item => item.handle === handle);  

      // console.log("label",label,"label.innerHTML",label.innerHTML,label.innerHTML.trim() === "");
    if (label && label.innerHTML.trim() === "") {
      // is_selected_any_product(input);
      label.innerHTML = labelText;
      const step_no = get_the_step_no(this);
      // Add new data if not already in localStorage
      if (index === -1) {
        stored.push({
          handle,
          name,
          quantity,
          step_no          
        });
        // stored.push({handle,name,type: isFirst ? "sensor" : isSecond ? "kabel" : "other",qty,});
      }

      // UI Update
      if (isFirst) {
        details?.querySelector(".after_sensor")?.classList.add("active");
        details?.querySelector(".befor_sensor")?.classList.remove("active");
      }
      if (isSecond) {
        details?.querySelector(".after_cabel")?.classList.add("active");
        details?.querySelector(".befor_cabel")?.classList.remove("active");
      }

      let input_val = card.querySelector(".quantity__input").value;  
      if(input_val && !card.classList.contains("active")){
        input_val = parseInt(input_val) + 1
        const qty_inp = card.querySelector(".quantity__input"); 
        if(qty_inp)qty_inp.value = input_val;
      }       
      renderSelectedProducts(handle, name, input_val, step_no);
    } else {        
    // If label has value (means already selected → remove)
      // isalready_selected_any_product(input);

      if (label) label.innerHTML = "";

      if(index_slot !== -1){
        stored_slot.splice(index, 1);
      }

      if (index !== -1) {        
        stored.splice(index, 1);
      }

      // UI Reset
      if (isFirst) {
        details?.querySelector(".after_sensor")?.classList.remove("active");
        details?.querySelector(".befor_sensor")?.classList.add("active");
      }
      if (isSecond) {
        details?.querySelector(".after_cabel")?.classList.remove("active");
        details?.querySelector(".befor_cabel")?.classList.add("active");
      }
    }

    localStorage.setItem("selectedProducts", JSON.stringify(stored));
    localStorage.setItem("slotproduct", JSON.stringify(stored_slot));

    //  Quantity listener (live update)
    if (qtyInput && !qtyInput.dataset.bound) {
      qtyInput.dataset.bound = "true";
      qtyInput.addEventListener("input", function () {
        const newQty = parseInt(this.value) || 1;
        // let stored = JSON.parse(localStorage.getItem("selectedProducts")) || [];
        const idx = stored.findIndex(item => item.handle === handle);
        const idx_slot = stored.findIndex(item => item.handle === handle);

        if(idx_slot !== -1){
          stored_slot[idx_slot].quantity = newQty;
          localStorage.setItem("slotproduct", JSON.stringify(stored_slot));
        }

        if (idx !== -1) {
          stored[idx].quantity = newQty;
          localStorage.setItem("selectedProducts", JSON.stringify(stored));
        }
      });
    }
  }

  getNextEmptySlot() {
    return this.slotInputs.find(input => !input.checked);
  }

  getSlotByHandle(handle) {
    return this.slotInputs.filter(input => {
      const slot = input.closest(".slot");
      return slot?.dataset.metaHandle === handle;
    });
  }
  
  fillSlot(index, parent, selector, input, variantId, handle, productTitle) {   
    const imgSrc = selector.dataset.slotImage;  
    const is_image_meta = selector.dataset.productIsImage;              
    const slotData = [{
      slotTop: selector.dataset.slotTop? Math.round(Number(selector.dataset.slotTop)): null,  
      slotRight: selector.dataset.slotRight? Math.round(Number(selector.dataset.slotRight)): null,    
      slotHeight: selector.dataset.slotHeight? Math.round(Number(selector.dataset.slotHeight)): null,    
      slotWidth: selector.dataset.slotWidth? Math.round(Number(selector.dataset.slotWidth)): null
    }];
    
    if(is_image_meta == "true"){      
      if (!imgSrc) return;   
      
       const slot_number =  parseInt(input.getAttribute('data-slot'),10) || null;
       console.log("slot_number",slot_number);
      const canvas_groupid = uploadImageFromURLES(window.canvas, imgSrc, slotData, slot_number);
      if(canvas_groupid){
       select_canvo_main(canvas_groupid);
         input.setAttribute(`data-canvas-group-id` , canvas_groupid);
         input.classList.add('active');
      }
    }
  
    input.checked = true;
    input.value = variantId;

    const slot = input.closest(".slot");
    slot.setAttribute("data-meta-handle", handle);

    const titleEl = slot.querySelector(".slot-title");
    const removeEl = slot.querySelector(".slot-controls")?.classList.remove("hidden");
    const removeInfoBtn = slot.querySelector(".slot-pdp-info-button")?.classList.remove("hidden");
    const select_msg = slot.querySelector(".select_third_product")?.classList.add("hidden");
    if (titleEl) titleEl.textContent = productTitle;
    const selected_title = slot.querySelector(".status_text_info")?.getAttribute("selecetd_title");
    slot.querySelector(".status_text_info").innerHTML = selected_title;
  }

  clearSlot(slotInput, index) {
    const slot = slotInput.closest(".slot");
    const metaHandle = slot.dataset.metaHandle;

    //image delete in image
    const imgSrc = slotInput.dataset.slotImage;  
    const is_image_meta = slotInput.dataset.productIsImage;      
    const get_image_attr = slotInput.getAttribute(`data-canvas-group-id`) || null;    
    if(get_image_attr){
      deleteObjectById(window.canvas,get_image_attr);
    }


    // check if any var-id matches then remove that div
    const sixth_step = document.querySelector(".show_selecetd_acc_product");
    const six_id = sixth_step?.querySelectorAll("metawise-variant-selector[data-product-var-id]");
    const currentVarId = slotInput.value;    
    Array.from(six_id).forEach(el => {
      if (el.dataset.productVarId === currentVarId) el.remove();         
    });

    slotInput.checked = false;
    slotInput.value = "";
   slot.removeAttribute('data-meta-handle');
  
    const titleEl = slot.querySelector(".slot-title");
    if (titleEl) titleEl.textContent = "";
    const removeEl = slot.querySelector(".slot-controls")?.classList.add("hidden");
    const removeInfoBtn = slot.querySelector(".slot-pdp-info-button")?.classList.add("hidden");
    
    const select_msg = slot.querySelector(".select_third_product")?.classList.remove("hidden");
  
    const selected_title = slot.querySelector(".status_text_info")?.getAttribute("unselected_title");
    slot.querySelector(".status_text_info").innerHTML = selected_title;  
  
    // --- 2. Clear card-level items ONLY if no slots remain for this handle ---
    if (metaHandle) {  
      const allSlots = Array.from(document.querySelectorAll(`.slot[data-meta-handle="${metaHandle}"]`));                   

      // Check if any slot is still filled
      const stillFilled = allSlots.some(s => {
        const input = s.querySelector(".meta-slot-input");        
        return input && input.value !== "";
      });
  
      // If ANY slot still has value → STOP (don't clear tag, qty, radio)
      if (stillFilled) {
        return;
      }
  
      // --- 3. Now safe to clear card values because ALL slots are empty ---
      const productCard = document.querySelectorAll(`.product-card[data-handle="${metaHandle}"]`);
      productCard.forEach(card => {        
        if (card) {  
          const occupied_slot = card.querySelector("[occcupied_slot]")?.getAttribute("occcupied_slot") || 1;          
          const qtyInput = card.querySelector(".quantity_product_card");
          // if (qtyInput) qtyInput.value = parseInt(occupied_slot);
          if (qtyInput && qtyInput.value > 0) qtyInput.value = (qtyInput.value - 1) ;
          const qty_parent = qtyInput?.closest("quantity-input")
          // qty_parent?.validateQtyRules(qtyInput);
          checkQtyButtonState(this); 
    
          const radio = card?.querySelector(".variant-radio:checked");
          if (radio) radio.checked = false;
          const checkbox = card?.querySelector(".variant-checkbox:checked");
          if(checkbox) checkbox.checked = true;
          const label = card?.querySelector(".selected_product_tag");
          if (label) label.innerHTML = "";
          // isalready_selected_any_product(radio);
        }
      });      
    } 
  }
  
  checkQtyButtonState(tag, currentRadio, totalQty) {      
    const is_multi_collaps = currentRadio?.closest(".multi_acc_seleceted");
    if(!is_multi_collaps){
      this.count_fill_qty = this.slotInputs.filter(i => i.checked).length;
      const allFilled = this.slotInputs.every(i => i.checked);
      const acc_design = this.querySelector(".is_accordion_design");      
      const parent = currentRadio?.closest(".product-card");
      const selecetd_tag = parent?.querySelector(".card__inner .selected_product_tag");

      const labelText = currentRadio?.dataset.tagText || "";    
      const select_btn = currentRadio?.closest(".product-grid")?.querySelectorAll(".variant-checkbox");    

      if(!allFilled) document.body.classList.remove("slot_full_open_popup");
      const is_slot_fill = document.body.classList.contains("slot_full_open_popup");
      if(is_slot_fill){
        select_btn?.forEach(btn => {
          const wrapper = btn.closest(".select_product");
          const parent = btn.closest(".product-card");
          const selecetd_tag = parent.querySelector(".card__inner .selected_product_tag");
          const check_all_tag = selecetd_tag.textContent.trim()|| null;                         
          if(check_all_tag){
               // popup up open
            const mainDiv = currentRadio.closest(".product-card-wrapper");
            if (!mainDiv) return;    
            // Check if .thirdMeta exists
              const popupElement = mainDiv.querySelector('.popup_data_info');               
              // const popupElement = mainDiv.querySelector(hasThirdMeta ? '.popup_data_info');          
              if (popupElement) {
                mainDiv.querySelector(".card_popup_content")?.classList.add("popup-active");
                popupElement.style.display = 'block';
                document.body.classList.add('popup-active');
              }  
              this.popDesc = popupElement.querySelector(".total_capacity");
              if(this.popDesc) this.popDesc.innerHTML = this.count_fill_qty;

              const totalQtyinp = popupElement.querySelector(".current_capacity");
              if(totalQtyinp) totalQtyinp.innerHTML = totalQty;
              
            // wrapper.style.pointerEvents = "initial";
            // btn.classList.remove("disabled");
          }else{          
            // wrapper.style.pointerEvents = "none";
            // btn.classList.add("disabled");
          }  
        });
      } else{        
        const selecetd_tag = parent.querySelector(".card__inner .selected_product_tag");
        currentRadio.checked = false;
        selecetd_tag.innerHTML = labelText;      
        if(allFilled) document.body.classList.add("slot_full_open_popup");
      }
  
      if (!tag) {       
        const sixth_step = document.querySelector(".show_selecetd_acc_product");
        const six_id = sixth_step?.querySelectorAll("metawise-variant-selector[data-product-var-id]");
        const currentVarId = currentRadio.dataset.varId;
        // check if any var-id matches then remove that div
        Array.from(six_id).forEach(el => {
          if (el.dataset.productVarId === currentVarId) el.remove();         
        });
      }        
      // plus button functionlity
      if(acc_design) return;
        const plusQty = document.querySelectorAll(".selected_product_data.active .plus_qty_product");
        // console.log("plusQty",plusQty);      
        if (allFilled) {                           
          plusQty.forEach(btn => {     
            btn.classList.add("disabled");            
            btn.style.pointerEvents = "none";
            const parent = btn.closest("quantity-input");
            // if (parent) parent.querySelector(".quantity_product_card").value = 1;
            // console.log("parent.querySelector.value",parent.querySelector(".quantity_product_card").value);  
          });    
        } else {      
          plusQty.forEach(btn => {                                             
            btn.classList.remove("disabled");
            btn.style.pointerEvents = "initial";
          });
        }
    }

  }

  checkInpNoProductDisable() {    
    const emptyInputs = this.slotInputs.filter(slot => {
      const input = slot.querySelector(".meta-slot-input");
      return !input || input.value.trim() === "";
    });
  
    // flag
    this.hasEmptyValue = emptyInputs.length > 0;  
    // disable pointer events
    emptyInputs.forEach(slot => {
      const input = slot.querySelector(".meta-slot-input");
      if (input) {
        input.style.pointerEvents = "none";
        input.style.opacity = "0.5"; // optional visual feedback
        input.style.cursor = "not-allowed";
      }  
    });
  }
  


  setupSlotInputChange() {
    this.slotInputs.forEach(input => {
      if (input.dataset.changeAdded === "true") return;
      input.dataset.changeAdded = "true";
  
      input.addEventListener("change", () => {
        if (!input.checked) {
          this.clearSlot(input);
          this.checkQtyButtonState(true, input);
        }       
      });
    });
  }

  extraQtyChangeSku(){
    this.querySelectorAll('.first_popcard_close')?.forEach(skuBtn => {
      skuBtn.addEventListener("click", async (event) => {
        // Prevent duplicate event listeners
        if (skuBtn.dataset.listenerAdded === "true") return;
        skuBtn.dataset.listenerAdded = "true";        
        // this.parent = skuBtn.closest(".product-card");          
        const parent = skuBtn.closest(".meta-wise-selected-variant");        
        const main_product = parent.querySelector(".selected_product_flex_meta");                
        const selectedVariantHandle = main_product.getAttribute("pre-selecetd-handle-pop");  
        const selecetdSkuStep = main_product.getAttribute('pre-selecetd-sku-pop') || null;        
        const mainDiv = skuBtn.closest(".product-card-wrapper");  
                
          if (selectedVariantHandle && selecetdSkuStep) {  
            const selected_product_function = await selecetd_product_show(selectedVariantHandle, skuBtn, selecetdSkuStep);                  
            const popupContent =  mainDiv.querySelector(".card_popup_content");
            if(popupContent) popupContent.classList.remove('popup-active');          
            document.body.classList.remove('popup-active');
            document.body.classList.add("is_rerender_step_fourth")
            const card_content = document.querySelector(".main-tab-products-content");
            const card_handle = card_content.querySelectorAll(".data-handle");
            const slotData = JSON.parse(localStorage.getItem("slotproduct") || "[]");          
            const slotHandles = new Set(slotData.map(p => p.handle));                            
              setTimeout(() => {           
                document.querySelectorAll(".main-tab-products-content .product-card-wrapper").forEach(card => {                  
                    if (!slotHandles.has(card.dataset.handle)) return;
                    card.querySelector(".variant-checkbox.cust_btn_select")?.click();
                });
              }, 1000);
          }else{
            const mainDiv = skuBtn.closest(".product-card-wrapper");    
            // Hide both possible popups
            const bothPopup = mainDiv?.querySelector(".popup_data, .popup_data_info");
              if(bothPopup) bothPopup.style.display = 'none';
            
            const popupContent =  mainDiv.querySelector(".card_popup_content");
              if(popupContent) popupContent.classList.remove('popup-active');
            
            document.body.classList.remove('popup-active');
          }       
      });
    });
  }

  popup_show_close(){
    this.querySelectorAll('.close_btn, .second_popcard_close, .third_popcard_close')?.forEach(closeBtn => {
      closeBtn.addEventListener("click", (event) => {
        event.stopPropagation();        
          const mainDiv = closeBtn.closest(".product-card-wrapper");
    
          // Hide both possible popups
          const bothPopup = mainDiv?.querySelector(".popup_data, .popup_data_info");
             if(bothPopup) bothPopup.style.display = 'none';
          
          const popupContent =  mainDiv.querySelector(".card_popup_content");
              if(popupContent) popupContent.classList.remove('popup-active');
          
          document.body.classList.remove('popup-active');
      });
    });
  }  

  setupRadioListeners() {
    const radios = this.querySelectorAll(".product-card .variant-radio");
    if (!radios.length) return;

    radios.forEach(radio => {
    if (radio.dataset.listenerAdded === "true") return;
    radio.dataset.listenerAdded = "true";

    radio.addEventListener("change", () => {      
      const variantId = radio.value;
      const card = radio.closest(".grid__item");
      const handle = radio.dataset.varHandle;
      const parent_section = radio.closest(".selected_product_data");      
      // const frame_capa = parseInt(parent_section?.querySelector("[data-frame-capacity]").getAttribute("data-frame-capacity"));   
      // console.log("frame_capa",frame_capa);   
      const productTitle = radio.dataset.productTitle;
      const parent = radio.closest(".product-card");
      const selecetd_tag = parent.querySelector(".card__inner .selected_product_tag");
      const labelText = radio.dataset.tagText || "";    
      const matchedSlot = this.getSlotByHandle(handle);                        
      this.is_multi_acc_show = radio.classList;
      this.input_wrap = radio.closest(".select_product");
      const totalQty = Array.from(radios)
      .filter(input => !input.value.includes(labelText))
      .reduce((sum, input) => {
        const card = input.closest(".product-card");
        const qty = parseInt(
          card?.querySelector(".quantity_product_card")?.value || "1",
          10
        );
        return sum + qty;
      }, 0);

      if (selecetd_tag.textContent.trim() === "" ) {         
        // is_selected_any_product(radio);
        const mainCard = radio.closest(".product-card");

        const main_input = mainCard.querySelector(".quantity_product_card") || null;
        if(!main_input) return;

        const occcupied_slot = main_input.getAttribute('occcupied_slot') || 1;
        const qty = parseInt(main_input.value || "1");

         const image_parent = parent_section?.querySelector(".selecetd_product_image");

        if(occcupied_slot ==1){
        
        for (let i = 0; i < qty; i++) {
          const emptySlot = this.getNextEmptySlot();          
          if (!emptySlot) break;
          this.fillSlot(i,image_parent, radio, emptySlot, variantId, handle, productTitle);
        }  
      }else{
          const emptySlot = this.getNextEmptySlot();    
         if (!emptySlot) return; 
         this.checkQtyButtonState(true, radio, totalQty);
         fillSlot_occcupied_slot(image_parent, radio, occcupied_slot, variantId, handle, productTitle,qty,this);

      }  

        this.handleSelection(radio);
        radio.checked = false;
        selecetd_tag.innerHTML = labelText;
        this.checkQtyButtonState(true, radio, totalQty);
        let input_val = card.querySelector(".quantity__input").value || 1;  
        if(input_val && !card.classList.contains("active")){
          input_val = parseInt(input_val) + 1
          const qty_inp = card.querySelector(".quantity__input"); 
            if(qty_inp)qty_inp.value = input_val;
        }   
        const step_no = get_the_step_no(input);

        renderSelectedProducts(handle, radio.name, input_val, step_no);
        if(this.is_multi_acc_show?.contains(".is_multi_selected_acc"))
          {
          multiProductsAccSelected(handle, radio.name);
        }        
      } else {     
      } 
      const allBlank = this.slotInputs.every(input => !input.checked);      
        if (allBlank) {
          // isalready_selected_any_product(radio); // run only on first selection
        }
           
    });    
    });
  }
  
  removePriductDeselected(handle){
    const products = document.querySelectorAll(".multi_acc_products");
    products.forEach(product => {
      const multi_pro_handle = product.dataset.handle;  
      if (multi_pro_handle === handle) {
        // product ne closest metawise-variant-selector (bahar no parent)
        const variantWrapper = product.closest(".metawise-variant-selector");        
        if (variantWrapper) {
          variantWrapper.remove();
        }
      }
    });
  }

  setupcheckboxListeners() {
  }
}

if (!customElements.get("metawise-variant-selector")) {
  customElements.define("metawise-variant-selector", MetaVariantSelector);
}



  function multiProductsAccSelected(allMetaValues, names) {
    // Normalize to arrays
    if (!Array.isArray(allMetaValues)) allMetaValues = [allMetaValues];
    if (!Array.isArray(names)) names = [names];
  
    // Remove duplicate handles
    const uniqueHandles = [...new Set(allMetaValues)];
    let stored = JSON.parse(localStorage.getItem("multiProductsAccSelected") || "[]");  
    let stored_slot = JSON.parse(localStorage.getItem("slotproduct") || "[]");

    for (let i = 0; i < uniqueHandles.length; i++) {
      const handle = uniqueHandles[i];
      const name = names[i] || "";
      const existingIndex = stored.findIndex(item => item.name === name);

      if (existingIndex !== -1) {
        stored[existingIndex].handle = handle;
      } else {
        stored.push({ handle, name, quantity: 1 });
      }
    }
  
    // Step 3: Save updated stored data back to localStorage
    localStorage.setItem("multiProductsAccSelected", JSON.stringify(stored));
  }

  async function multi_acc_card_product(handle,blockId,index) {    
    try {
      const response = await fetch(`/products/${handle}?view=multi_acc_card_product&block_id=${blockId}`);
      const productHTML = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(productHTML, 'text/html');
      const mainDivEl = doc.querySelector('.card_product_custom');   
      if(mainDivEl){
        const time_stemp = Date.now();       
       let input = mainDivEl.querySelector(".variant-checkbox.cust_btn_select") || null; 
       let label = input?.nextElementSibling;    
      //  console.log("input before",input,"blockId",blockId,"time_stemp",time_stemp,"index",index);
        // input = `contact[__product__meta_wise_filter_pro-${blockId}-${time_stemp}-${index}]`
        if(input){
           const originalId = input.id || "meta_input";
            const newId = `${originalId}-${blockId}-${time_stemp}-${index}`;
            input.id = newId;
            input.setAttribute(
              "name",
              `contact[__product__meta_wise_filter_pro-${blockId}-${time_stemp}-${index}]`
            );
              if (label) {
                  label.setAttribute("for", newId);
                }

          }
        // console.log("input after",input);
        return mainDivEl;
      }else{
        return null;
      }
      return   
  
    } catch (error) {
      console.error('Error fetching product info:', error);
      return null;
    }
  }

  //========== selected filter data show in mobile ============//
class selecetdProductTagMobile extends HTMLElement {
  constructor() {
    super();   
    this.init();
  }

  init() {
    this.selecetdPorductTagText(this);
  }

  async selecetdPorductTagText(current_this) {
    const tabInputs = current_this?.querySelectorAll("input.button_tab_inp");
    const variantRadios = current_this?.querySelectorAll(".select_product input.variant-radio");   

    function handleSelection(input) {
      const card = input.closest(".grid__item");
      const tab = input.closest(".selecetd_product_tab");
      const details = card?.closest(".pro-card-details");
      const label = card?.querySelector(".selected_product_tag");
      const qtyInput = card?.querySelector(".quantity__input.quantity_product_card");
  
      const meta_filed_wise = input.closest("metawise-variant-selector");
      if (meta_filed_wise) return;
      if (!tab || !card) return;
  
      const isFirst = tab.hasAttribute("data-first-collection");
      const isSecond = tab.hasAttribute("data-second-collection");
  
      const handle = input.dataset.varHandle;
      const name = input.name;
      const labelText = input.dataset.tagText || "";
      const qty = parseInt(qtyInput?.value || "1", 10);    
      
      let stored = JSON.parse(localStorage.getItem("selectedProducts")) || [];  
      const index = stored.findIndex(item => item.handle === handle);     
      let input_val = card.querySelector(".quantity__input").value || 1;  
      if(input_val && !card.classList.contains("active")){
        input_val = parseInt(input_val) + 1
        const qty_inp = card.querySelector(".quantity__input"); 
          if(qty_inp)qty_inp.value = input_val;
      }   
      const step_no = get_the_step_no(input);
      
      if (label && label.innerHTML.trim() === "") {      
        // is_selected_any_product(input);
        label.innerHTML = labelText;
  
        // Add new data if not already in localStorage
        if (index === -1) {
          stored.push({
            handle,
            name,
            type: isFirst ? "sensor" : isSecond ? "kabel" : "other",
            quantity,
          });
        }
  
        // UI Update
        if (isFirst) {
          details?.querySelector(".after_sensor")?.classList.add("active");
          details?.querySelector(".befor_sensor")?.classList.remove("active");
        }
        if (isSecond) {
          details?.querySelector(".after_cabel")?.classList.add("active");
          details?.querySelector(".befor_cabel")?.classList.remove("active");
        }
  
        renderSelectedProducts(handle, name, input_val, step_no);
      } else {        
      // If label has value (means already selected → remove)
        // isalready_selected_any_product(input);

        if (label) label.innerHTML = "";
  
        if (index !== -1) {
          stored.splice(index, 1);
        }
  
        // UI Reset
        if (isFirst) {
          details?.querySelector(".after_sensor")?.classList.remove("active");
          details?.querySelector(".befor_sensor")?.classList.add("active");
        }
        if (isSecond) {
          details?.querySelector(".after_cabel")?.classList.remove("active");
          details?.querySelector(".befor_cabel")?.classList.add("active");
        }
      }
  
      localStorage.setItem("selectedProducts", JSON.stringify(stored));
  
      //  Quantity listener (live update)
      if (qtyInput && !qtyInput.dataset.bound) {
        qtyInput.dataset.bound = "true";
        qtyInput.addEventListener("input", function () {
          const newQty = parseInt(this.value) || 1;
          let stored = JSON.parse(localStorage.getItem("selectedProducts")) || [];
          const idx = stored.findIndex(item => item.handle === handle);
          if (idx !== -1) {
            stored[idx].quantity = newQty;
            localStorage.setItem("selectedProducts", JSON.stringify(stored));
          }
        });
      }
    }
  
    tabInputs?.forEach(input => {
      input.addEventListener("change", () => handleSelection(input));
    });
  
    variantRadios?.forEach(input => {
      input.addEventListener("click", () => handleSelection(input));
    });
  }
}

class customfilterMobileProduct extends selecetdProductTagMobile {
  constructor() {
    super();   
    // this.init();
  }

  init() {
    this.collectionid = this.getAttribute('data-col-api-id') || null;
    if(this.collectionid){
       this.getdataforapi();       
    }else{
          this.getInputForEventTarget();
    }
  }

  async getInputForEventTarget(filterParam = null, selectedValue = null) {   
     const filter_data = this.querySelector(".filter-data");   
    if(filter_data){             
      const collectionInfo = await this.getcollectionInfo(filter_data.dataset.collection);      
      if(collectionInfo){
        filter_data.innerHTML = "";

        filter_data.appendChild(collectionInfo); 
        await this.selecetdPorductTagText(this);
        // filter dropdown 
        // const filter_dropdown = collectionInfo.querySelectorAll(".filter_main_default");    
        // filter_dropdown.forEach((filter) => {
        //   filter?.addEventListener('click', async (f) => { 
          
        //     const dropdowns =  filter.closest(".scadas_mobile_filter_wrapp")?.querySelectorAll("ul.filter-radio-list");                 
        //     const dropdown = filter.closest("filter-option-select")?.querySelector("ul.filter-radio-list");
        //     const isActive = dropdown?.classList.contains("active");

        //     dropdowns?.forEach((d) => d?.classList.remove("active"));

        //     if (!isActive) {
        //       dropdown?.classList.add("active");
        //     }                                        
        //   });
        // });
      }
    }    
  }

  async getcollectionInfo(handle) {
    try {
      const is_que = handle.includes('?');
      var params = ""; 
      if(is_que){
        var params = "&";   
      }else{
        var params = "?";  
      }
      const response = await fetch(`${handle}${params}view=custom_filter`);    
      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }
      const productHTML = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(productHTML, 'text/html'); 
      const filter_data = doc.querySelector(".tag_filter_list_scadas_mobile");
      return filter_data;
  
    } catch (error) {
      console.error('Error fetching product info:', error);
      return null;
    }
  }

  async productwisefiltershow(e, This) {

  
      // // Close dropdown
      // const dropdown = e.target.closest("ul.filter-radio-list");
      // dropdown?.classList.remove("active");
  
      // Group values by key
      const grouped = new Map();  
      this.querySelectorAll(".selecetd_filter:checked").forEach((input) => {
        const key = input.dataset.filterParam;
        const type = input.dataset.listCheck ?? input.dataset.type ?? "list";
        const value = input.value.trim();
  
        if (!key || !value) return;  
        if (!grouped.has(key)) {
          grouped.set(key, { key, type, values: [] });
        }
        grouped.get(key).values.push(value);
      });
  
      // Build ONLY the "filter" array
      const filter = Array.from(grouped.values()).map((item) => ({
        key: item.key,
        type: item.type,
        value: item.values.join(",")
      }));
        
      this.data = JSON.parse(this.dataset.metafildsJsinApi); 
      this.data.filter = filter;           
       if(!this.data.product_id) this.data = updateMainObject(this.data, this.data.filter); 
       if(this.data.get_main_first && window.firstIdStored) this.data.product_id =  window.firstIdStored;
      const collectionInfo = await load_product_api(this.data);          
      SpinnerAdd();      
      await this.productHtmlUpdate(collectionInfo);
      SpinnerRemove(); 
    
  }
  

    // remove filter function function 
  async RemoveFilter(event, This,Key){
      event.preventDefault();
      // this.data = JSON.parse(this.dataset.metafildsJsinApiReset);
      this.data = {
        ...this.data,
        metafields: this.data.metafields.filter(item => item.key !== Key),
        ...(this.data.filter && {
          filter: this.data.filter.filter(item => item.key !== Key)
        })
      };
      this.collection_name = this.product_data.querySelector("[data-first-collection]");     
              const filter_data = this.getAttribute("data-collection-url");                
              const collectionInfo = await load_product_api(this.data);                 
              SpinnerAdd();
              await this.productHtmlUpdate(collectionInfo);  
              SpinnerRemove();                    
                                       
                    This.closest('ul')?.querySelectorAll(".selecetd_filter").forEach(function(checkbox) {
                      checkbox.checked = false;                       
                    });                            
  }

  // get product base on custom API
  async getdataforapi() {   
     this.product_data = this.closest('metawise-variant-selector') || null;           
    if(this.product_data){       
      const el = this.product_data.querySelector('[data-product-id-cust-api]') || null;      
      if(!el) return
         this.data = JSON.parse(this.dataset.metafildsJsinApi); 
         this.collection_name = this.product_data.querySelector("[data-first-collection]");     
        const filter_data = this.getAttribute("data-collection-url");
        const window_firstIdStored = this.data;
        if(this.data.get_main_first && window.firstIdStored) {
          this.data.product_id =  window.firstIdStored;
        console.log("30-march... after",this.data);
        }

        const collectionInfo = await load_product_api(this.data); 
        //  SpinnerAdd(); 
        // console.log("getdataapi....");
        await this.productHtmlUpdate(collectionInfo);     
                             console.log("after the es")
                //  const filter_vall = await this.productwisefiltershow();
            }    
            SpinnerRemove();
  }

  async productHtmlUpdate(collectionInfo){
    const container = this.closest('metawise-variant-selector')?.querySelector(this.getAttribute('data-tab-selector')); 
    this.is_multi_step = this.closest("configure-form")?.querySelector(".sixth_step .show_selecetd_collaps_product");      
    const block_id = this.is_multi_step?.getAttribute("data-block-id");   
    if (!container) return;
    if(!collectionInfo){
      container.innerHTML = "product not found";  
    }

    // end
    // const cardEl = await pagination_collection(collectionInfo);  
    // if (cardEl) container.appendChild(cardEl);
    // console.log("cardEl",cardEl,"collectionInfo",collectionInfo);  

    let items = [];
    // Check Array or Object
      if (Array.isArray(collectionInfo)) {
        items = collectionInfo;     // direct array
      } else if (typeof collectionInfo === "object") {
        items = Object.entries(collectionInfo);                  
      } else {
        console.warn("collectionInfo is neither array nor object");
        return;
      }                      
      container.innerHTML = "";    
        SpinnerAdd();       
      // for (let item of items) {
      for (let [index, item] of items.entries()) {
          let handle;                         
        if (Array.isArray(collectionInfo)) {
          handle = item;
        } else {
          handle = item[1];  // object case value
        }
        var cardEl = ""  

        const wrapper = document.createElement("div");
        wrapper.className = `grid__item filters-${this.collection_name} cust-product-card-wrapper`;        
        if(this.is_multi_step){
          cardEl = await multi_acc_card_product(handle,block_id,index);            
          if (!cardEl) continue;          
        }else{
          cardEl = await cardProduct(handle);            
          if (!cardEl) continue;
        }

        const productId = cardEl.getAttribute("data-product-id");        
        wrapper.id = `filters-${this.collection_name}-${productId}`;
        wrapper.appendChild(cardEl);
        container.appendChild(wrapper);
      }      

      // pre selected
      const is_remove = true;
      // filteredProductshow(this,is_remove);      

      // setTimeout(() => {        
        handleAnimationFrame(container);
      // }, 1000);
      // const card_content = document.querySelector(".main-tab-products-content");
      // const card_handle = card_content.querySelectorAll(".data-handle");
      const slotData = JSON.parse(localStorage.getItem("slotproduct") || "[]");
      const render_section = document.body.classList.contains("is_rerender_step_fourth");
       
       if (Array.isArray(slotData) && slotData.length > 0 && render_section ) {
         const slotHandles = new Set(slotData.map(p => p.handle));                             
          document.querySelectorAll(".main-tab-products-content .product-card-wrapper").forEach(card => {      
            // console.log("slotHandles.has(card.dataset.handle)",slotHandles.has(card.dataset.handle))           
                if (!slotHandles.has(card.dataset.handle) && card.closest('.sixth-step')) return;
                card.querySelector(".variant-checkbox.cust_btn_select")?.click();
          });   
          document.body.classList.remove("is_rerender_step_fourth")
       }
  }
}
if (!customElements.get('cust-filter-mobile-product')) {
  customElements.define('cust-filter-mobile-product', customfilterMobileProduct);
}

function handleAnimationFrame(datas){
  console.log("datas",datas);    

  let data = datas.closest("[pre-data-pre-products]") || datas;  
  let data_attr = null;  
  if(datas.closest("[pre-data-pre-products]")){
    const parent_meta =  datas.closest("metawise-variant-selector");
    console.log("parent_meta",parent_meta);
      let check_preselecte_sensor = parent_meta.getAttribute("pre_product_sensoren") || null;
      let check_preselecte_kabel = parent_meta.getAttribute("pre_product_kabel") || null;
      let is_contains_sensor = datas.getAttribute("data-collection").includes("sensor");
      let is_contains_kabel = datas.getAttribute("data-collection").includes("kabel");
      const is_sensor_selected = document.querySelector(".green-dot.after_sensor.active") || null;
      const is_kabel_selected = document.querySelector(".green-dot.after_cabel.after_sensor.active") || null;
      if(check_preselecte_sensor || check_preselecte_kabel ){        
        if(is_contains_sensor && check_preselecte_sensor != null){
           data_attr = check_preselecte_sensor;
        }else if(is_contains_kabel && check_preselecte_kabel != null){
          data_attr = check_preselecte_kabel;
        }
      }
  }
  if(!data) return;  
  const normalizeHandle = (str) =>str.toString().trim().toLowerCase().replace(/®/g, '').replace(/\s+/g, '');    
  let collection = data.getAttribute("pre-data-pre-products") !== null ? data : null;  

  if(!collection && data_attr) collection = data;
console.log("collection",collection);
  if( collection !=  null){  
    console.log("inside the if....");
    let preProductAttrsen_keb_ = "";
    const is_clicked_pre_selected = document.querySelector(".clicked_according");
    if(is_clicked_pre_selected !=  null){   
        if(data_attr){
          preProductAttrsen_keb_ = data_attr || '';             
        } else{
          // preProductAttrsen_keb_ = collection?.getAttribute('pre-data-pre-products') || '';             
        }  
                   
        // preProductAttrsen_keb = preProductAttrsen_keb_.split(",").map(item => {
        //   const [handle, quantity] = item.split("^_^");

        //    console.log("handle:", handle);
        //    console.log("quantity:", quantity);

        //   return {
        //     handle: normalizeHandle(handle),
        //     quantity: quantity || 1
        //   };
        // });
        preProductAttrsen_keb = preProductAttrsen_keb_.split(",").map(item => {
          const [handle, quantity] = item.split("^_^");
          const extractedHandle = handle.includes(":-)")? handle.split(":-)")[1]: handle;

          return {
            handle: normalizeHandle(extractedHandle),
            quantity: quantity || 1
          };
        });
      

        const cards = collection.querySelectorAll("[data-product-handle]");                        
        cards.forEach(card => {              
          const rawHandle = card.getAttribute("data-product-handle");
          const productHandle = normalizeHandle(rawHandle);           
          const matched = preProductAttrsen_keb.find(p => p.handle === productHandle);          
          if (!matched) return;
          const qtyInput = card.querySelector("input.quantity__input.quantity_product_card");
          const match_qty = parseInt(matched.quantity) - 1;
          if (qtyInput) {
            qtyInput.value ="";            
            qtyInput.value = match_qty;
          }

          const variantCheckbox = card.querySelector("input.variant-checkbox[type='checkbox']");              
          if (variantCheckbox && !variantCheckbox.checked) {     
            variantCheckbox.click();  
            console.log("after click...");
          }
        });   
    }   
  }else{    
    console.log("inside the else....");
    const main_product = document.querySelector(".accordion__content.clicked_according");         
    const preProductAttrKarten = main_product?.querySelector("[pre_product_karten]")?.getAttribute("pre_product_karten") || '';          
    
    if (!preProductAttrKarten){
      SpinnerRemove();
        return;
    }                
      // const parsedProducts = preProductAttrKarten.split(",").map(item => {
      //     const [handle, quantity] = item.split("^_^");
      //     const extractedHandle = handle.includes(":-)")? handle.split(":-)")[1]: handle;

      //     return {
      //       handle: normalizeHandle(extractedHandle),
      //       quantity: quantity || 1
      //     };
      //   });

   const parsedProducts = preProductAttrKarten.split(",").map(item => {
      const [handle, quantity] = item.split("^_^");
      console.log("handle",handle);
      console.log("quantity",quantity);
      return {
        handle: normalizeHandle(handle),
        quantity: quantity || 1
      };
    });
    console.log("data....",data,"parsedProducts",parsedProducts);
    const cards = data.querySelectorAll("[data-product-handle]");    
    cards.forEach(card => {              
      const rawHandle = card.getAttribute("data-product-handle");
      const productHandle = normalizeHandle(rawHandle);    
      const matched = parsedProducts.find(p => p.handle === productHandle);
      console.log("matched",matched)
      if (!matched) return;

      const qtyInput = card.querySelector("input.quantity__input.quantity_product_card");
      const qty_val = parseInt(matched.quantity);
      if (qtyInput) {
        qtyInput.value ="";
        console.log("qtyInput",qtyInput,"matched.quantity",matched.quantity);
        // qtyInput.value = matched.quantity;       
      }

      const variantCheckbox = card.querySelector("input.variant-checkbox[type='checkbox']");    
      if (variantCheckbox && !variantCheckbox.checked) {  
        console.log("variantCheckbox",variantCheckbox,"qty_val",qty_val);   
        for (let i = 0; i < qty_val; i++) {          
        
          variantCheckbox.click();
      }
      }
    });
  }   

  SpinnerRemove();

  // const pre_product_karten = document.querySelector("[pre_product_karten]")?.getAttribute("pre_product_karten");
  // if(!pre_product_karten) SpinnerRemove();   
}